import { useMutation, useQuery } from "@tanstack/react-query";
import { createOrderNewsletter, getNewsletter } from "domain/Newsletter/api";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button from "ui/Button";
import { toast } from "react-toastify";
import { getParameterByName } from "lib/url";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AnimatedModal from "components/Modal/AnimatedModal";
import { useSelector } from "react-redux";
import { getGameTypeById } from "domain/Directories/selectors";
import { DateTime as Luxon } from "luxon";
import { gameTypes } from "domain/GamesSearch/types";

const Newsletter = ({ gameId, gameData }) => {
    const history = useHistory();
    const payment = getParameterByName("newsletter");
    const [isShow, setIsShow] = useState(false);

    const { type_id, starts_at, organizer, is_training, trainer } = gameData;

    const { data, refetch } = useQuery({
        queryKey: ["newsletter", { gameId }],
        queryFn: () => getNewsletter(gameId),
        enabled: !!gameId,
    });

    const isPaySuccess =
        data?.payment_status === "succeeded" ||
        data?.payment_status === "waiting_for_capture"
            ? true
            : false;
    const gameType = useSelector((state) => getGameTypeById(state, type_id));
    const startDT = Luxon.fromSQL(starts_at);

    useEffect(() => {
        if (payment) {
            let url = new URL(document.location.href);
            url.searchParams.delete("newsletter");
            history.replace(url.pathname + url.search);
            refetch();
            setIsShow(true);
        }
    }, []);

    const createPayment = () => {
        const return_url = `${window.location.href}?newsletter=${gameId}`;
        pay.mutate({ game_id: gameId, return_url });
    };

    const onSuccess = (data) => {
        if (data?.confirmation_url) {
            window.location.href = data.confirmation_url;
        }
    };

    const onError = (err) => {
        toast.error(`Ошибка: ${err.message}`);
    };

    const onClose = () => {
        setIsShow(false);
    };

    const pay = useMutation(createOrderNewsletter, { onSuccess, onError });

    return (
        <>
            {data && !isPaySuccess && (
                <div className="card-full__newsletter">
                    <h3 className="card-full__newsletter-title">
                        Пригласить игроков на игру
                    </h3>

                    <p className="card-full__text-content">{data?.message}</p>

                    <div className="card-full__newsletter-footer">
                        <div className="card-full__newsletter-content">
                            <p className="fs-caption c-gs-label">
                                Стоимость услуги
                            </p>
                            <p className="card-full__newsletter-price">
                                {data?.price} рублей
                            </p>
                        </div>
                        <Button primary onClick={createPayment}>
                            Пригласить
                        </Button>
                    </div>
                </div>
            )}

            {isShow && (
                <>
                    {isPaySuccess ? (
                        <AnimatedModal
                            visible={isShow}
                            title={"Вы оплатили рассылку приглашений на игру"}
                            onClose={onClose}
                            closeOnOverlay={true}
                            modificators={[`min-padding`]}
                        >
                            {(close) => (
                                <>
                                    <p className="text-center c-gs-medium-em mb-32">
                                        {gameType.name}.{" "}
                                        {startDT.toFormat("dd.LL.yyyy")} в{" "}
                                        {startDT.toLocaleString(
                                            Luxon.TIME_24_SIMPLE
                                        )}
                                        . Организатор -{" "}
                                        {`${organizer.family_name} ${organizer.name}`}
                                        {is_training &&
                                            trainer &&
                                            `, тренер - ${trainer.family_name} ${trainer.name}`}
                                    </p>

                                    <div className="btn-group-row">
                                        <Button
                                            primary
                                            size="medium"
                                            mixes={[`m-x-auto`]}
                                            onClick={close}
                                        >
                                            <span className="btn__span">
                                                Ок
                                            </span>
                                        </Button>
                                    </div>
                                </>
                            )}
                        </AnimatedModal>
                    ) : (
                        <AnimatedModal
                            visible={true}
                            title={"Во время оплаты произошла ошибка"}
                            onClose={onClose}
                            closeOnOverlay={true}
                            modificators={[`min-padding`]}
                        >
                            {(close) => (
                                <>
                                    <p className="text-center c-gs-medium-em mb-32">
                                        Приносим свои извинения за неудобства,
                                        попробуйте оплатить еще раз
                                    </p>
                                    <div className="btn-group-row">
                                        <Button
                                            primary
                                            size="medium"
                                            mixes={[`m-x-auto`]}
                                            onClick={close}
                                        >
                                            <span className="btn__span">
                                                Ок
                                            </span>
                                        </Button>
                                    </div>
                                </>
                            )}
                        </AnimatedModal>
                    )}
                </>
            )}
        </>
    );
};

Newsletter.propTypes = {
    gameId: PropTypes.number,
    ...gameTypes,
};

export default Newsletter;
